import { type ColorSystemOptions } from '@mui/material/styles';

import { dark, light, whatsapp } from './tokens';

declare module '@mui/material/styles' {
  interface Palette {
    whatsapp: Palette['primary'];
    surfaceVariant: string;
  }
  interface PaletteOptions {
    whatsapp?: PaletteOptions['primary'];
    surfaceVariant?: string;
  }
}

declare module '@mui/material/Button' {
  interface ButtonPropsColorOverrides {
    whatsapp: true;
  }
}

const whatsappColor = {
  main: whatsapp.main,
  dark: whatsapp.hover,
  contrastText: whatsapp.onMain,
};

export const lightScheme: ColorSystemOptions = {
  palette: {
    primary: { main: light.primary, dark: light.primaryHover, contrastText: light.onPrimary },
    secondary: { main: light.ink, contrastText: light.surface },
    success: { main: light.success },
    warning: { main: light.warning },
    error: { main: light.error },
    info: { main: light.info },
    whatsapp: whatsappColor,
    background: { default: light.background, paper: light.surface },
    surfaceVariant: light.surfaceVariant,
    text: { primary: light.ink, secondary: light.inkMuted, disabled: light.inkDisabled },
    divider: light.divider,
  },
};

export const darkScheme: ColorSystemOptions = {
  palette: {
    primary: { main: dark.primary, dark: dark.primaryHover, contrastText: dark.onPrimary },
    secondary: { main: dark.ink, contrastText: dark.background },
    success: { main: dark.success },
    warning: { main: dark.warning },
    error: { main: dark.error },
    info: { main: dark.info },
    whatsapp: whatsappColor,
    background: { default: dark.background, paper: dark.surface },
    surfaceVariant: dark.surfaceVariant,
    text: { primary: dark.ink, secondary: dark.inkMuted, disabled: dark.inkDisabled },
    divider: dark.divider,
  },
};
